/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {
    ComponentFactoryResolver,
    Directive,
    ElementRef,
    HostListener,
    Inject,
    Input,
    ViewContainerRef
} from '@angular/core';
import {IF_ACTIVE_ID, IfActiveService} from '../../utils/conditional/if-active.service';
import {TemplateRefContainer} from '../../utils/template-ref/template-ref-container';
import {AriaService} from './aria-service';
import {TABS_ID} from './tabs-id.provider';

let /** @type {?} */ nbTabLinkComponents: number = 0;
export class TabLinkDirective {
     inOverflow: boolean;
    templateRefContainer: TemplateRefContainer;
/**
 * @param {?} ifActiveService
 * @param {?} id
 * @param {?} ariaService
 * @param {?} el
 * @param {?} cfr
 * @param {?} viewContainerRef
 * @param {?} tabsId
 */
constructor(public ifActiveService: IfActiveService,
private id: number,
private ariaService: AriaService,
private el: ElementRef,
private cfr: ComponentFactoryResolver,
private viewContainerRef: ViewContainerRef,
public tabsId: number) {
        if (!this.tabLinkId) {
            this.tabLinkId = "clr-tab-link-" + (nbTabLinkComponents++);
        }

        // Tab links can be rendered in one of two places: in the main area or inside the overflow dropdown menu.
        // Here, we create a container so that its template can be used to create embeddedView on the fly.
        // See TabsService's renderView() method and how it's used in Tabs class for an example.
        const factory = this.cfr.resolveComponentFactory(TemplateRefContainer);
        this.templateRefContainer =
            this.viewContainerRef.createComponent(factory, 1, undefined, [[this.el.nativeElement]]).instance;
    }
/**
 * @return {?}
 */
get ariaControls(): string {
        return this.ariaService.ariaControls;
    }
/**
 * @return {?}
 */
get tabLinkId(): string {
        return this.ariaService.ariaLabelledBy;
    }
/**
 * @param {?} id
 * @return {?}
 */
set tabLinkId(id: string) {
        this.ariaService.ariaLabelledBy = id;
    }
/**
 * @return {?}
 */
activate() {
        this.ifActiveService.current = this.id;
    }
/**
 * @return {?}
 */
get active() {
        return this.ifActiveService.current === this.id;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: "[clrTabLink]",
    host: {
        "[id]": "tabLinkId",
        "[attr.aria-selected]": "active",
        "[attr.aria-controls]": "ariaControls",
        "role": "presentation",
        "[class.btn]": "true",
        "[class.btn-link]": "!inOverflow",
        "[class.nav-link]": "!inOverflow",
        "[class.nav-item]": "!inOverflow",
        "[class.active]": "active"
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: IfActiveService, },
{type: undefined, decorators: [{ type: Inject, args: [IF_ACTIVE_ID, ] }, ]},
{type: AriaService, },
{type: ElementRef, },
{type: ComponentFactoryResolver, },
{type: ViewContainerRef, },
{type: undefined, decorators: [{ type: Inject, args: [TABS_ID, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'inOverflow': [{ type: Input, args: ["clrTabLinkInOverflow", ] },],
'tabLinkId': [{ type: Input, args: ["id", ] },],
'activate': [{ type: HostListener, args: ["click", ] },],
};
}

function TabLinkDirective_tsickle_Closure_declarations() {
/** @type {?} */
TabLinkDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabLinkDirective.ctorParameters;
/** @type {?} */
TabLinkDirective.propDecorators;
/** @type {?} */
TabLinkDirective.prototype.inOverflow;
/** @type {?} */
TabLinkDirective.prototype.templateRefContainer;
/** @type {?} */
TabLinkDirective.prototype.ifActiveService;
/** @type {?} */
TabLinkDirective.prototype.id;
/** @type {?} */
TabLinkDirective.prototype.ariaService;
/** @type {?} */
TabLinkDirective.prototype.el;
/** @type {?} */
TabLinkDirective.prototype.cfr;
/** @type {?} */
TabLinkDirective.prototype.viewContainerRef;
/** @type {?} */
TabLinkDirective.prototype.tabsId;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
